import utils from 'utils';
import { isDateRestrictedByContract } from 'utils/reservation';
import RESERVATIONS from 'constants/reservations';

const { EXCHANGE_TYPE_PICKUP, EXCHANGE_TYPE_RETURN } = RESERVATIONS;

export const showEveryDayLowRatesBanner = (type, date, pickupDate, returnDate, contractRestrictions) => {
  // check both pickup and return dates restrictions
  let restrictedDate = false;
  if (type === EXCHANGE_TYPE_PICKUP) {
    restrictedDate =
      (date && isDateRestrictedByContract(type, date, contractRestrictions)) ||
      (returnDate &&
        isDateRestrictedByContract(
          EXCHANGE_TYPE_RETURN,
          utils.gmi.getDateTimeObjFromTs(returnDate),
          contractRestrictions
        ));
  } else {
    restrictedDate =
      (date && isDateRestrictedByContract(type, date, contractRestrictions)) ||
      (pickupDate &&
        isDateRestrictedByContract(
          EXCHANGE_TYPE_PICKUP,
          utils.gmi.getDateTimeObjFromTs(pickupDate),
          contractRestrictions
        ));
  }
  return restrictedDate;
};
